import React, { memo, useState, useEffect } from 'react';
import UploadImgComponent from '../../../components/Dashboard-res/CommonComponent/UploadImgComponent';
import arrow_icon from '../../../images/icons/BlueArrow.svg';
import DocImage from '../../../images/icons/docImage.svg';
import MaleImage from '../../../images/icons/male.svg';
import Female from '../../../images/icons/UserKycIcons/female_icon.svg';
import CommonInput from '../../../components/Dashboard-res/CommonComponent/CommonInput';
import { useFormikContext } from 'formik';
import CommonDatePicker from '../../../components/Dashboard-res/CommonComponent/CommonDatePicker';
import get from 'lodash/get';
import CommonPincode from '../../../components/Dashboard-res/CommonComponent/CommonPincode';
import CommonSelect from '../../../components/Dashboard-res/CommonComponent/CommonSelect';
import GlobalUploadComp from '../../../common/components/GlobalUploadComp/GlobalUploadComp';
import ResidentialAdress from '../ResidentialAddress/ResidentialAdress';
import './Aadhar.css';
import PopUp from '../../../common/components/PopUp/PopUp';
import { useFormikWizard } from 'formik-wizard';
import {
  UserKycUpload,
  UploadFileToS3,
  UserKycOcr,
  GETAPI,
  UserKycSave
} from '../../../common/constants/api';
import initialImg from '../../../images/icons/upload_new.svg';
import { getApplicantionInfo } from '../../../common/utils/applicantionInfo';
import common_gender from '../../../images/icons/UserKycIcons/common_gender.svg';
import mb_reupload from '../../../images/icons/mb_upload.svg';
import moment from 'moment';
import { ShowGetImage } from '../../../common/components/ShowGetImage/ShowGetImage';

let StateList = [
  'Andhra Pradesh',
  'Arunachal Pradesh',
  'Assam',
  'Bihar',
  'Chhattisgarh',
  'Goa',
  'Gujarat',
  'Haryana',
  'Himachal Pradesh',
  'Jammu and Kashmir',
  'Jharkhand',
  'Karnataka',
  'Kerala',
  'Madhya Pradesh',
  'Maharashtra',
  'Manipur',
  'Meghalaya',
  'Mizoram',
  'Nagaland',
  'Odisha',
  'Punjab',
  'Rajasthan',
  'Sikkim',
  'Tamil Nadu',
  'Telangana',
  'Tripura',
  'Uttarakhand',
  'Uttar Pradesh',
  'West Bengal',
  'Andaman and Nicobar Islands',
  'Chandigarh',
  'Dadra and Nagar Haveli',
  'Daman and Diu',
  'Delhi',
  'Lakshadweep',
  'Puducherry'
];

const AadharPostUpload = () => {
  const {
    values,
    data,
    setData,
    handleChange,
    errors,
    touched,
    handleBlur,
    setFieldError,
    setFieldValue,
    name,
    setFileUploadErrors,
    fileUploadErrors,
    setFieldTouched,
    handleSubmit,
    validateForm
  } = useFormikContext();

  const [skip, setSkip] = useState(false);
  const [uploadDone, setUploadDone] = useState(false);
  const [uploadExcepted, setUploadExcepted] = useState(false);
  const [pincodeError, setPincodeError] = useState(false);
  const [isSubmit, setSubmit] = useState(false);
  const [postSave, setPostSave] = useState(false);
  const [DocIdFront, setFrontDocId] = useState(false);
  const [docIdBack, setBackDocId] = useState(false);
  const [leadId, setLeadId] = useState(getApplicantionInfo().leadId);
  const [applicantId, setApplicantId] = useState(
    getApplicantionInfo().leadApplicantId
  );
  const [Loading, setLoading] = useState(false);
  const [show, setShow] = useState(true);
  const [fileUploadedTos3, setFileUploadedTos3] = useState(false);
  const [frontfileUploadedTos3, setFrontFileUploadedTos3] = useState(false);
  const [errorMessageShow, setErrorMessageIfAny] = useState(false);
  const [AnyError, setAnyerrorOccued] = useState(false);
  const [PreviousData, setPreviousData] = useState(false);
  const [frontPage, setFront] = useState(false);
  const [backPage, setBack] = useState(false);

  const handleError = err => {
    setLoading(false), setAnyerrorOccued(true), setErrorMessageIfAny(err);
    setTimeout(function() {
      setAnyerrorOccued(false);
    }, 3000);
  };
  useEffect(() => {
    setLoading(true);
    GETAPI(leadId, applicantId, 'aadhaar')
      .then(res => {
        if (res.error) {
          throw new Error(res);
        }
        let links = res.links;
        let front,
          back,
          frontDocId = 0,
          backdocId = 0;
        for (let i = 0; i < res.links.length; i++) {
          if (
            links[i].docId &&
            links[i].tag == 'frontPage' &&
            links[i].docId > frontDocId
          ) {
            frontDocId = links[i].docId;
            front = links[i].url;
          } else if (
            links[i].docId &&
            links[i].tag == 'backPage' &&
            links[i].docId > backdocId
          ) {
            backdocId = links[i].docId;
            back = links[i].url;
          }
        }
        if (front) {
          setFieldValue('Pfront', front);
        }
        if (back) {
          setFieldValue('Pback', back);
        }

        if ((links.length != 0 || res.userData) && (front || back)) {
          let userData = res.userData;
          if (userData) {
            let address = userData.address;
            let dob = moment(userData.dob);
            setFieldValue('aadhar_no', userData?.aadharNumber),
              setFieldValue('address_line_1', address.line1),
              setFieldValue('address_line_2', address.line2),
              setFieldValue('city', address.city, ''),
              setFieldValue('state', {
                label: address['state'],
                value: address['state']
              }),
              setFieldValue('pincode', address.pinCode ? address.pinCode : ''),
              setFieldValue('name', userData?.name, ''),
              setFieldValue('gender', userData?.gender, '');
            setFieldValue(
              'month',
              {
                label: parseInt(dob.month()) + 1,
                value: parseInt(dob.month()) + 1
              },
              ''
            );
            setFieldValue('date', { label: dob.date(), value: dob.date() }, '');
            setFieldValue('year', { label: dob.year(), value: dob.year() }, '');
          }

          setPreviousData(true);
          setUploadDone(true);
          setUploadExcepted(true);
          setAnyerrorOccued(false);
          setSubmit(true);
        }
        setLoading(false);
      })
      .catch(errr => {
        setErrorMessageIfAny(errr?.response?.data?.message.toString());
        setAnyerrorOccued(true);
        setLoading(false);
      });
  }, []);

  const setToInitial = page => {
    setPreviousData(false);
    setUploadDone(true);
    setUploadExcepted(false);
    setAnyerrorOccued(false);
    setSubmit(false);
    if (page == 'front') setFront(true);
    if (page == 'back') setBack(true);
  };

  useEffect(() => {
    if (frontfileUploadedTos3) {
      setUploadDone(true);
      if (fileUploadedTos3) {
        setBack(true);
      }
      setFront(true);
    }
  }, [fileUploadedTos3, frontfileUploadedTos3]);

  useEffect(() => {
    if (values.file.length >= 1 && values.file[0]) {
      setLoading(true);
      setFront(false);
      UserKycUpload(values.file[0], leadId, applicantId, 'aadhaar', 'frontPage')
        .then(res => {
          if (res.error) {
            throw new Error(res.error.data.message);
          }
          UploadFileToS3(res.url, values.file[0][0])
            .then(res1 => {
              if (res1.error) {
                throw new Error('Not uploaded');
              }
              setFrontFileUploadedTos3(true), setLoading(false);
              setFront(true);
            })
            .catch(err1 => handleError(err1));
          setFrontDocId(res);
        })
        .catch(err => handleError(err));
    }
  }, [values.file[0]]);

  useEffect(() => {
    if (values.file.length >= 2 && values.file[1]) {
      setBack(false);
      setLoading(true);
      UserKycUpload(values.file[1], leadId, applicantId, 'aadhaar', 'backPage')
        .then(res => {
          if (res.error) {
            throw new Error(res.error.data.message);
          }

          UploadFileToS3(res.url, values.file[1][0])
            .then(res1 => {
              if (res1.error) {
                throw new Error('Not uploaded');
              }

              setFileUploadedTos3(true);
              setLoading(false);
              setBack(true);
            })
            .catch(err1 => handleError(err1));
          setBackDocId(res);
        })
        .catch(err => handleError(err));
    }
  }, [values.file[1]]);

  useEffect(() => {
    const CallOcr = async () => {
      if (uploadExcepted && !PreviousData) {
        if (frontPage) {
          setLoading(true);

          setFront(false);
          await UserKycOcr(leadId, applicantId, DocIdFront.requestId, 'aadhaar')
            .then(res => {
              setLoading(false);

              if (res.error) {
                throw new Error(res.error.data.message);
              }
              let dob = res.kycEntries.dob.value.toString().split('/');
              setFieldValue('aadhar_no', res.kycEntries.aadharNumber.value);
              setFieldValue('gender', res.kycEntries.gender.value);
              setFieldValue('name', res.kycEntries.name.value);
              setFieldValue('year', { value: dob[2], label: dob[2] });
              setFieldValue('month', { value: dob[1], label: dob[1] });
              setFieldValue('date', { value: dob[0], label: dob[0] });
            })
            .catch(err => setLoading(false));
        }
        if (backPage) {
          setBack(false);
          setLoading(true);

          await UserKycOcr(leadId, applicantId, docIdBack.requestId, 'aadhaar')
            .then(res => {
              setLoading(false);
              if (res.error) {
                throw new Error(res.error.data.message);
              }

              let address = res.kycEntries.address.value
                .toString()
                .split(/,|- /);
              for (let i = 0; i < address.length; i++) {
                if (address[i]) {
                  for (let j = 0; j < StateList.length; j++) {
                    if (
                      address[i]
                        .toString()
                        .trim()
                        .toLowerCase() ==
                      StateList[j]
                        .toString()
                        .trim()
                        .toLowerCase()
                    ) {
                      setFieldValue('state', {
                        value: StateList[j],
                        label: StateList[j]
                      });
                      setFieldValue('city', address[i - 1]);
                    }
                  }
                  if (
                    !isNaN(address[i].toString().trim()) &&
                    address[i].toString().trim().length == 6
                  ) {
                    setFieldValue('pincode', address[i].toString().trim());
                  }
                }
              }
              let address_1 = address,
                address_2 = address;
              address_1 = address_1
                .slice(1, parseInt(address.length / 2))
                .join(',');
              address_2 = address_2
                .slice(parseInt(address.length / 2), address.length)
                .join(',');
              setFieldValue('address_line_2', address_2);
              setFieldValue('address_line_1', address_1)
                .then(e => setLoading(false))
                .catch(err => setLoading(false));
            })
            .catch(err => setLoading(false));
        }
      }
    };
    const getOcrOfAadhar = async () => {
      await CallOcr();
    };
    getOcrOfAadhar();
  }, [uploadExcepted, frontPage, backPage]);

  useEffect(() => {
    setFieldValue('file', []);
    setFieldValue('imgUrl', []);

    return () => {};
  }, []);

  const SubmitAadharOCRData = () => {
    setFieldValue(
      'address',
      values.address_line_1 +
        ' ' +
        values.address_line_2 +
        ' ' +
        (values.address_line_1.includes(values.city) ||
        values.address_line_2.includes(values.city)
          ? ''
          : values.city) +
        ' ' +
        (values.address_line_1.includes(values.state.value) ||
        values.address_line_2.includes(values.state.value)
          ? ''
          : values.state.value) +
        (values.address_line_1.includes(values.pincode) ||
        values.address_line_2.includes(values.pincode)
          ? ''
          : '-' + values.pincode)
    );

    setLoading(true);
    let body = {
      name: values.name,
      gender: values.gender,
      aadharNumber: values.aadhar_no,
      address: {
        line1: values.address_line_1,
        line2: values.address_line_2,
        city: values.city,
        state: values.state.value,
        pinCode: values.pincode
      },
      dob:
        values.year.value +
        '-' +
        (values.month.value.toString().length == 2
          ? values.month.value
          : '0' + values.month.value) +
        '-' +
        (values.date.value.toString().length == 2
          ? values.date.value
          : '0' + values.date.value)
    };

    UserKycSave(leadId, applicantId, body, 'aadhaar')
      .then(e => {
        if (e.error) {
          throw new Error(res.error.data.message);
        }
        setLoading(false);
      })
      .catch(err => {
        handleError(err);
        try {
          console.log(err);
          setErrorMessageIfAny(err.message);
        } catch {}
        setPostSave(false);
      });
  };

  const savePropertyType = () => {
    setLoading(true);
    let body = {
      isOwned: values.PropertyType == 'owned' ? true : false,
      ownedBy: values.PropertyType == 'owned' ? values.OwnedBy : '',
      rentPerMonth: values.PropertyType == 'owned' ? 0 : values.monthlyRent,
      name: {
        firstName: values.firstName,
        middleName: values.middleName,
        lastName: values.lastName
      },
      relation: values.relationShip.value
    };

    UserKycSave(leadId, applicantId, body, 'residency')
      .then(res => {
        if (res.error) {
          throw new Error(res.data.message);
        }
        setLoading(false);
        handleSubmit();
      })
      .catch(err => {
        setAnyerrorOccued(true);
        setErrorMessageIfAny(err.toString());
      });
  };

  const handlePropertyType = () => {
    validateForm().then(res => {
      if (Object.keys(res).length == 0) {
        savePropertyType();
      } else {
        handleSubmit();
      }
    });
  };

  return (
    <div className="">
      <div className="block md:hidden w-full bg-purple-200 flex  py-4 rounded px-2 items-center">
        <div className="w-4/12 ">
          <img src={DocImage} />
        </div>
        <div className="w-7/12 block px-2 ">
          <p className="font-roboto font-normal text-blue-900">Step 3</p>
          <p className="font-roboto font-medium text-blue-900">
            Now please upload Aadhaar card
          </p>
        </div>
        <div className="ml-auto pr-3 text-blue-900  ">
          <img src={arrow_icon} />
        </div>
      </div>

      {!postSave ? (
        <Aadhar
          values={values}
          data={data}
          setData={setData}
          handleChange={handleChange}
          errors={errors}
          touched={touched}
          handleBlur={handleBlur}
          setFieldError={setFieldError}
          setFieldValue={setFieldValue}
          name={name}
          setFileUploadErrors={setFileUploadErrors}
          fileUploadErrors={fileUploadErrors}
          setFieldTouched={setFieldTouched}
          handleSubmit={handleSubmit}
          setToInitial={setToInitial}
        />
      ) : null}
      {uploadExcepted && !postSave ? (
        <AdhaarDataFields
          values={values}
          data={data}
          setData={setData}
          handleChange={handleChange}
          errors={errors}
          touched={touched}
          handleBlur={handleBlur}
          setFieldError={setFieldError}
          setFieldValue={setFieldValue}
          name={name}
          setFileUploadErrors={setFileUploadErrors}
          fileUploadErrors={fileUploadErrors}
          setFieldTouched={setFieldTouched}
        />
      ) : null}
      {postSave ? (
        <div className="">
          <ResidentialAdress
            values={values}
            data={data}
            setData={setData}
            handleChange={handleChange}
            errors={errors}
            touched={touched}
            handleBlur={handleBlur}
            setFieldError={setFieldError}
            setFieldValue={setFieldValue}
            name={name}
            setFileUploadErrors={setFileUploadErrors}
            fileUploadErrors={fileUploadErrors}
            setFieldTouched={setFieldTouched}
            handleSubmit={handleSubmit}
          />
        </div>
      ) : null}
      <div className="md:inset-x-0 md:bottom-0 md:py-5">
        {uploadDone ? (
          <button
            type="button"
            className="submitButton font-roboto text-white text-base w-48 "
            disabled={
              isSubmit
                ? errors.name ||
                  values.name == '' ||
                  errors.aadhar_no ||
                  values.aadhar_no == '' ||
                  values.date.value == '' ||
                  values.month.value == '' ||
                  values.year.value == '' ||
                  errors.address_line_1 ||
                  values.address_line_1 == '' ||
                  errors.city ||
                  values.city == '' ||
                  values.state.value == '' ||
                  errors.pincode ||
                  values.pincode == '' ||
                  values.gender == ''
                : null
            }
            onClick={() => {
              if (values.currentAddress == 'no') {
                handleSubmit();
              }
              if (
                values.currentAddress == 'yes' &&
                values.PropertyType != 'rented' &&
                values.OwnedBy
              ) {
                handlePropertyType();
              }

              if (values.PropertyType == 'rented' && values.monthlyRent) {
                handlePropertyType();
              } else if (!isSubmit) {
                setUploadExcepted(true), setSubmit(true);
                setLoading(true);
              } else if (isSubmit && !postSave) {
                setPostSave(true), SubmitAadharOCRData();
              }
            }}
          >
            {!isSubmit ? (
              <>
                <span className="hidden md:block">Upload</span>
                <span className="md:hidden block">Next</span>
              </>
            ) : (
              <span className="block">Save & Verify</span>
            )}
          </button>
        ) : null}
      </div>
      {Loading ? (
        <PopUp
          type="loading"
          text="Loading ...."
          setShow={setShow}
          show={true}
        />
      ) : null}
      {AnyError ? (
        <PopUp
          type="fail"
          text={errorMessageShow.toString()}
          setShow={setShow}
          show={true}
        />
      ) : null}
    </div>
  );
};

const Aadhar = props => {
  const {
    values,
    setData,
    handleChange,
    errors,
    touched,
    handleBlur,
    setFieldError,
    setFieldValue,
    name,
    setFileUploadErrors,
    fileUploadErrors,
    setFieldTouched,
    handleSubmit,
    setToInitial
  } = props;

  const setEditFront = () => {
    setFieldValue('Pfront', false), setToInitial('front');
  };

  const setEditBack = () => {
    setFieldValue('Pback', false), setToInitial('back');
  };

  return (
    <div className="w-full ">
      <div className="bg-grey-1008 md:bg-white  px-3 w-full py-5 rounded h-full  pb-9 md:pb-20  block shadow md:shadow-none">
        <div className="w-full flex py-5">
          <h2 className="font-roboto font-medium  text-base mr-auto text-black-1100">
            Upload Your Aadhar Card
          </h2>
          <h2
            className="font-roboto font-medium  text-base ml-auto text-green-1000 cursor-pointer"
            onClick={() => {
              setFieldValue('SkipAadhar', true).then(e => handleSubmit());
            }}
          >
            SKIP
          </h2>
        </div>
        <div className="bg-white border border-navy-200  md:border-0 w-full px-2 md:px-0 rounded-lg py-4 md:py-0 max-w-2xl">
          <p className="md:hidden block font-roboto font-normal text-grey-2100 mr-auto py-3 text-sm">
            Upload Your Aadhaar Card
          </p>
          <div className=" w-full flex flex-wrap lg:pr-4 lg:px-5 lg:mx-auto items-center">
            <div className="block py-4 mr-5 ml-0">
              {!values.Pfront ? (
                <GlobalUploadComp
                  data={values}
                  imgIndex={0} //0,1,2,3 depending upon the no of file sequence
                  errors={errors}
                  touched={touched}
                  handleChange={handleChange}
                  handleBlur={handleBlur}
                  setFieldValue={setFieldValue}
                  setFieldTouched={setFieldTouched}
                  setFieldError={setFieldError}
                  initialImg={initialImg} // initial image
                  subInst="Click here Upload Front Page of Aadhar"
                  subtext="Upload Front"
                />
              ) : (
                <ShowGetImage img={values.Pfront} setEdit={setEditFront} />
              )}
            </div>

            <div className="block py-4 mr-auto">
              {!values.Pback ? (
                <GlobalUploadComp
                  data={values}
                  imgIndex={1} //0,1,2,3 depending upon the no of file sequence
                  errors={errors}
                  touched={touched}
                  handleChange={handleChange}
                  handleBlur={handleBlur}
                  setFieldValue={setFieldValue}
                  setFieldTouched={setFieldTouched}
                  setFieldError={setFieldError}
                  initialImg={initialImg} // initial image
                  subInst="Click here Upload Back Page of Aadhar"
                  subtext="Upload back"
                />
              ) : (
                <ShowGetImage img={values.Pback} setEdit={setEditBack} />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const AdhaarDataFields = props => {
  const {
    values,
    data,
    setData,
    handleChange,
    errors,
    touched,
    handleBlur,
    setFieldError,
    setFieldValue,
    name,
    setFileUploadErrors,
    fileUploadErrors,
    setFieldTouched
  } = props;
  const [gender, setGender] = useState('');
  const [pincodeDeatils, setPincodeDetails] = useState('');
  const [statusFilterList, setStatusFilterList] = useState([]);
  const [state, setState] = useState('');
  useEffect(() => {
    let StateListArray = [];

    StateList.sort().map(each =>
      StateListArray.push({
        label: each,
        value: each
      })
    );
    setStatusFilterList(StateListArray);
  }, []);

  return (
    <div className="md:bg-white px-4 md:px-10 py-8 md:py-1">
      <div className="flex-1  w-full">
        <p className="font-roboto font-normal text-grey-920 text-base ">
          Gender
        </p>
        <div className={' w-full flex '}>
          <div
            className={values.gender == 'MALE' ? 'assignedImg' : 'assignImg'}
            onClick={() => setFieldValue('gender', 'MALE')}
          >
            <img className="cursor-pointer px-2 " src={MaleImage} />
          </div>
          <div
            className={values.gender == 'FEMALE' ? 'assignedImg' : 'assignImg'}
            onClick={() => setFieldValue('gender', 'FEMALE')}
          >
            <img className="cursor-pointer px-2" src={Female} />
          </div>
          <div
            className={values.gender == 'transg' ? 'assignedImg' : 'assignImg'}
            onClick={() => setFieldValue('gender', 'transg')}
          >
            <img className="cursor-pointer px-2" src={common_gender} />
          </div>
        </div>
        {errors.gender ? <p className="text-red-100 pt-2">Required</p> : null}

        <div className="block py-10">
          <div className="w-full lg:flex block">
            <div className="w-full lg:w-5/12  py-3 ">
              <CommonInput
                name="name"
                disabled=""
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.name}
                stylesContainer={{
                  height: '52px',
                  maxWidth: '100%'
                }}
                legendName="Full Name as per Aadhaar card"
                error={touched.name && errors.name}
                errorMsg={errors.name}
                touched={touched.name}
              />
            </div>
            <div className="w-full lg:w-5/12  py-3 mr-auto lg:ml-7 ">
              <CommonInput
                name="aadhar_no"
                type='tel'
                disabled=""
                onChange={e => {
                  if (!isNaN(e.target.value) && e.target.value.length <= 12) {
                    handleChange(e);
                  }
                }}
                onBlur={handleBlur}
                value={values.aadhar_no}
                stylesContainer={{
                  height: '52px',
                  maxWidth: '100%'
                }}
                legendName="Aadhaar Number"
                error={touched.aadhar_no && errors.aadhar_no}
                errorMsg={errors.aadhar_no}
                touched={touched.aadhar_no}
              />
            </div>
          </div>
          <div className="lg:flex block">
            <div className="w-full lg:w-5/12 md:w-12/12 mr-auto  py-3 md:mr-auto ">
              <div className="text-black-600 font-roboto font-normal text-xs pb-2">
                DOB
              </div>

              <CommonDatePicker
                onChangeMonth={(value, isValidDate) => {
                  setFieldValue('month', value, true);

                  setFieldTouched('month', true, false);
                  if (!isValidDate) {
                    setFieldValue(
                      'date',
                      {
                        value: '',
                        label: 'Date'
                      },
                      true
                    );
                  }
                }}
                onChangeYear={(value, isValidDate) => {
                  setFieldValue('year', value, true);
                  setFieldTouched('year', true, false);

                  if (!isValidDate) {
                    setFieldValue(
                      'date',
                      {
                        value: '',
                        label: 'Date'
                      },
                      true
                    );
                  }
                }}
                onChangeDate={value => {
                  setFieldValue('date', value, true);
                  setFieldTouched('date', true, false);
                }}
                valueMonth={values.month}
                valueYear={values.year}
                valueDate={values.date}
                errorYear={touched.year && get(errors, 'year.value', false)}
                touchedYear={touched.year}
                onBlurYear={() => {
                  setFieldTouched('year', true, true);
                }}
                errorMonth={touched.month && get(errors, 'month.value', false)}
                touchedMonth={touched.month}
                onBlurMonth={() => {
                  setFieldTouched('month', true, true);
                }}
                // errors.date.value
                errorDate={touched.date && get(errors, 'date.value', false)}
                touchedDate={touched.date}
                onBlurDate={() => {
                  setFieldTouched('date', true, true);
                }}
                //  errorMsg= "DOB is not selected"git
                type="dob"
              />
            </div>
          </div>

          <div className="w-full lg:flex block ">
            <div className="w-full lg:w-5/12   py-3 ">
              <CommonInput
                name="address_line_1"
                disabled=""
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.address_line_1}
                stylesContainer={{
                  height: '52px',
                  maxWidth: '100%'
                }}
                legendName="Address Line 1"
                error={touched.address_line_1 && errors.address_line_1}
                errorMsg={errors.address_line_1}
                touched={touched.address_line_1}
              />
            </div>
            <div className="w-full lg:w-5/12   py-3 mr-auto lg:ml-7">
              <CommonInput
                name="address_line_2"
                disabled=""
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.address_line_2}
                stylesContainer={{
                  height: '52px',
                  maxWidth: '100%'
                }}
                legendName="Address Line 2"
                error={touched.address_line_2 && errors.address_line_2}
                errorMsg={errors.address_line_2}
                touched={touched.address_line_2}
              />
            </div>
          </div>
          <div className="w-full flex  ">
            <div className="w-full lg:w-5/12  py-5 py-9 ">
              <CommonInput
                name="city"
                disabled=""
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.city}
                stylesContainer={{
                  height: '52px',
                  maxWidth: '100%'
                }}
                legendName="City"
                error={touched.city && errors.city}
                errorMsg={errors.city}
                touched={touched.city}
              />
            </div>

            <div className="w-full lg:w-5/12 mr-auto py-3 md:py-3  ml-7 ">
              <div className="text-black-600 font-roboto font-normal text-xs pb-2">
                State
              </div>

              <CommonSelect sort={true}
                name="state"
                value={values.state}
                onChange={e => {
                  setFieldValue('state', { value: e.value, label: e.value });
                }}
                options={statusFilterList}
                isHoverEffect
                stylesContainer={{
                  height: '52px',
                  marginBottom: '0px',
                  fontSize: '40px'
                }}
                dropdownStyle={{
                  top: '52px',
                  color: 'rgba(0,0,0,0.87)',
                  fontSize: '16px',
                  backgroundColor: '#fff',
                  alignItems: 'center',
                  fontFamily: 'Roboto',
                  fontWeight: 400
                }}
                styleText={{
                  fontSize: '14px',
                  padding: '0 25px'
                }}
                error={touched.state && get(errors, 'state.value', false)}
                touched={touched.state}
                onBlur={e => {
                  () => {};
                }}
              />
            </div>
          </div>
          <div className="w-full lg:flex block ">
            <div className="w-5/12 mr-auto   py-5 md:py-3">
              <CommonPincode
                name="pincode"
                value={values.pincode}
                onChange={e => {
                  if (e.target.value.length <= 6 && !isNaN(e.target.value)) {
                    handleChange(e);
                    setFieldValue('pinCoderesolved', false);
                  }
                }}
                stylesContainer={{
                  height: '52px',
                  maxWidth: '100%'
                }}
                error={
                  get(errors, 'pincode', false) &&
                  get(touched, 'pincode', false)
                }
                errorMsg={get(errors, 'pincode', false)}
                touched={get(touched, 'pincode', false)}
                onPinCodeSucessOrFailure={obj => {
                  const { err, data: pincodeData } = obj;

                  if (!err && pincodeData) {
                    setFieldValue('pinCoderesolved', true);
                    setFieldValue('pincodeCity', pincodeData.District),
                      setFieldValue('pincodeState', pincodeData.State);
                  } else {
                    setFieldError('pincode', 'Pincode is not valid');
                  }
                }}
                onBlur={e => {
                  handleBlur(e);
                }}
              />
              {values.pinCoderesolved || errors.pincode ? (
                <p
                  className={
                    (errors.pincode ? 'text-red-500' : 'text-green-500') +
                    ' pt-2 text-xs'
                  }
                >
                  {errors.pincode
                    ? null
                    : values.pincodeCity + ',   ' + values.pincodeState}
                </p>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default memo(AadharPostUpload);
